import { Stack, Typography } from '@mui/material';

import { INFORMATION_SECTION_CARD_SX } from '../styles';
import { TREATMENT_PLAN_V3_SECTION_HEADING_SX } from '../../../../styles';

import type { InformationSectionCardProps } from './types';

export default function InformationSectionCard({ title, children }: InformationSectionCardProps) {
  return (
    <Stack gap={2} sx={INFORMATION_SECTION_CARD_SX}>
      <Typography variant="h6" sx={TREATMENT_PLAN_V3_SECTION_HEADING_SX}>
        {title}
      </Typography>
      {children}
    </Stack>
  );
}
